import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setPortalDashboardObject } from "../reducers/portalDashboard";
import type { GetPortalDashboardObjectResponse } from "@ServerTypes/portal/portal.schema";

export function getPortalObject() {
  return (dispatch: AppDispatch) => {
    axiosWrapper
      .get<GetPortalDashboardObjectResponse>(`${getBackendUrl()}/portal/getPortalDashboardObject`)
      .then((res) => {
        if (res.data.status) {
          dispatch(setPortalDashboardObject((res.data as any).data));
        }
      })
      .catch((err: unknown) => {
        console.log("Error in portal dahboard object", err);
        Promise.reject(err);
      });
  };
}
